import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ChangeContractNameCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  async run(contract_id: number, new_name: string, reason: string, user_id: number, staff_username: string): Promise<any> {
    let args = {
      contract_id: contract_id,
      new_name: new_name,
      reason: reason,
      user_id: user_id,
      staff_username: staff_username
    };
    try {
      const result = await this.dispatcher.dispatch('change.contract.name', args);
      return result;
    } catch(error) {
      console.error('Error al cambiar nombre del contrato', error)
      throw error;
    }
  }
}
